import React from 'react';

/**
 * 보안 기능 섹션 컴포넌트
 */
function SecuritySection() {
  return (
    <section id="security" className="guide-section">
      <h2>🛡️ 보안 기능</h2>
      
      <div className="feature-grid">
        <div className="feature-card">
          <h3>💪 패스워드 강도 분석</h3>
          <div className="feature-steps">
            <p><strong>실시간 분석:</strong></p>
            <ul>
              <li>🔴 약함 (0-25점)</li>
              <li>🟡 보통 (26-50점)</li>
              <li>🟢 강함 (51-75점)</li>
              <li>🔵 매우 강함 (76-100점)</li>
            </ul>
            
            <p><strong>분석 요소:</strong></p>
            <ul>
              <li>📏 길이 (8자 이상 권장)</li>
              <li>🔤 대소문자 조합</li>
              <li>🔢 숫자 포함</li>
              <li>🔣 특수문자 포함</li>
            </ul>
          </div>
        </div>

        <div className="feature-card">
          <h3>🎲 안전한 패스워드 생성기</h3>
          <div className="feature-steps">
            <p><strong>생성 옵션:</strong></p>
            <ul>
              <li>📏 길이: 8-128자</li>
              <li>🔤 대문자 포함/제외</li>
              <li>🔢 숫자 포함/제외</li>
              <li>🔣 특수문자 포함/제외</li>
            </ul>
            
            <p><strong>사용법:</strong></p>
            <ol>
              <li>패스워드 입력란 옆 🎲 버튼 클릭</li>
              <li>생성 옵션 설정</li>
              <li>"생성" 버튼으로 새 패스워드 생성</li>
              <li>"사용" 버튼으로 적용</li>
            </ol>
          </div>
        </div>

        <div className="feature-card">
          <h3>🔄 중복 패스워드 감지</h3>
          <div className="feature-steps">
            <p><strong>감지 기능:</strong></p>
            <ul>
              <li>✅ 정확한 중복 감지</li>
              <li>⚠️ 유사한 패스워드 경고</li>
              <li>📊 중복 사용 통계</li>
              <li>🎯 개선 권장사항</li>
            </ul>
            
            <p><strong>확인 방법:</strong></p>
            <ol>
              <li>🛡️ "보안 권장사항" 버튼 클릭</li>
              <li>"문제점" 탭에서 중복 패스워드 확인</li>
              <li>해당 패스워드들 수정</li>
            </ol>
          </div>
        </div>

        <div className="feature-card">
          <h3>📊 보안 권장사항</h3>
          <div className="feature-steps">
            <p><strong>보안 등급 시스템:</strong></p>
            <ul>
              <li>🅰️ A등급: 매우 안전</li>
              <li>🅱️ B등급: 안전</li>
              <li>🆔 C등급: 보통</li>
              <li>🆔 D등급: 위험</li>
            </ul>
            
            <p><strong>4가지 분석 탭:</strong></p>
            <ol>
              <li>📊 개요: 전체 보안 현황</li>
              <li>⚠️ 문제점: 개선 필요 사항</li>
              <li>💡 권장사항: 구체적 개선 방법</li>
              <li>📈 분석: 상세 통계 정보</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SecuritySection;